import { render, staticRenderFns } from "./setPwd.vue?vue&type=template&id=f365cba2&scoped=true&"
import script from "./setPwd.vue?vue&type=script&lang=js&"
export * from "./setPwd.vue?vue&type=script&lang=js&"
import style0 from "./setPwd.vue?vue&type=style&index=0&id=f365cba2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f365cba2",
  null
  
)

export default component.exports